





























































































































































































































































































































































































import { Component, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import {
  alertStore,
  modalErrorStore,
  systemParameterStore
} from '@/utils/store-accessor'
import {
  Alert,
  AlertMessage,
  defaultSystemCode,
  defaultUser,
  defaultUserAddress,
  ErrorMessage,
  MailAddress,
  SystemCode,
  User,
  UserAddress,
  userApi,
  UserPhone
} from '@/api'
import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'
import { AlertFactory } from '@/factory'
import { isEqual } from 'lodash'
import CODE_KEY from '@/config/code_key'
import { AlertCodeAL400013, AlertCodeTL400016 } from '@/types'
import { InputUserId } from '@/components/molecules/InputUserId'

interface ModalUserIntegrationInterface {
  id: string
  isGroup: boolean
  userType: SystemCode
  branchCode: SystemCode
  userStatus: SystemCode
  name: string
  expirationDate: string
  birthday: string
  nameKana: string
  gender: SystemCode
  userAddress: UserAddress
  phones: UserPhone[]
  mailAddresses: MailAddress[]
  onUpdated: Function
}

const defaultModalUserIntegrationInterface = (): ModalUserIntegrationInterface => ({
  id: '',
  isGroup: false,
  userType: defaultSystemCode(),
  branchCode: defaultSystemCode(),
  userStatus: defaultSystemCode(),
  name: '',
  expirationDate: '',
  birthday: '',
  nameKana: '',
  gender: defaultSystemCode(),
  userAddress: defaultUserAddress(),
  phones: [],
  mailAddresses: [],
  onUpdated: () => {}
})

@Component({
  components: {
    InputUserId,
    ModalFooter
  }
})
export default class ModalUserIntegration extends ComponentVue {
  @Ref()
  integrationInputUserId!: InputUserId

  interface: ModalUserIntegrationInterface = defaultModalUserIntegrationInterface()

  dialog: boolean = false

  integrationUser: User = defaultUser()

  inputUserId: string = ''

  get userPhoneNumber(): string {
    return this.interface.phones.length > 0
      ? this.interface.phones[0].number
      : ''
  }

  get userPhoneType(): string {
    return this.interface.phones.length > 0
      ? this.interface.phones[0].type.shortName
      : ''
  }

  get userMailAddress(): string {
    return this.interface.mailAddresses.length > 0
      ? this.interface.mailAddresses[0].address
      : ''
  }

  get userMailAddressType(): string {
    return this.interface.mailAddresses.length > 0
      ? this.interface.mailAddresses[0].type.shortName
      : ''
  }

  get integrationUserIsGroup(): boolean {
    return this.integrationUser.group.name !== ''
  }

  get integrationUserPhoneNumber(): string {
    const phones = this.integrationUserIsGroup
      ? this.integrationUser.group.phones
      : this.integrationUser.personal.phones

    return phones.length > 0 ? phones[0].number : ''
  }

  get integrationUserPhoneType(): string {
    const phones = this.integrationUserIsGroup
      ? this.integrationUser.group.phones
      : this.integrationUser.personal.phones

    return phones.length > 0 ? phones[0].type.shortName : ''
  }

  get integrationUserMailAddress(): string {
    const mailAddresses = this.integrationUserIsGroup
      ? this.integrationUser.group.mailAddresses
      : this.integrationUser.personal.mailAddresses

    return mailAddresses.length > 0 ? mailAddresses[0].address : ''
  }

  get integrationUserMailAddressType(): string {
    const mailAddresses = this.integrationUserIsGroup
      ? this.integrationUser.group.mailAddresses
      : this.integrationUser.personal.mailAddresses

    return mailAddresses.length > 0 ? mailAddresses[0].type.shortName : ''
  }

  get existsIntegrationUser(): boolean {
    return isEqual(this.integrationUser, defaultUser())
  }

  open(params: ModalUserIntegrationInterface): void {
    this.dialog = true
    this.interface = params

    systemParameterStore.fetchAllAndMergeByCodeKeys([
      CODE_KEY.NUMBER_MANAGEMENT.KEY
    ])
  }

  close(): void {
    this.interface = defaultModalUserIntegrationInterface()

    this.dialog = false
  }

  onClickPrint(): void {
    const element = document.getElementById('modal-user-integration')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  clear() {
    this.integrationUser = defaultUser()
    this.inputUserId = ''
  }

  userIcon(isGroup: boolean): string {
    if (isGroup) return 'users'
    return 'male'
  }

  userIconState(status: SystemCode): string {
    if (status.code === '1') return 'male'
    return 'invalid'
  }

  openModalUserSearch() {
    this.$modalUserSearch.open({
      onClickOk: (userId: string) => {
        this.onOkModalUserSearch(userId)
      }
    })
  }

  onOkModalUserSearch(id: string) {
    this.fetchIntegrationUser(id)
  }

  async fetchIntegrationUser(id: string) {
    if (id === this.interface.id) {
      const alert: Alert = AlertFactory.create(AlertCodeTL400016)
      alertStore.setItem(alert)
      this.modalAlert()
      return
    }

    try {
      this.integrationUser = await userApi.getUser({
        id
      })
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.modalAlert()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalAlert.open()
      } else {
        console.error(error)
      }
    }
  }

  onClickIntegrate() {
    const alert: Alert = AlertFactory.create(AlertCodeAL400013)
    alertStore.setItem(alert)
    this.$modalAlert.open({
      onOkClick: () => {
        this.integrate(this.integrationUser.base.id, this.interface.id)
      }
    })
  }

  async integrate(userId: string, targetUserId: string) {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await userApi.integrate(userId, targetUserId)
      await this.interface.onUpdated()
      this.close()
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  modalAlert() {
    this.$modalAlert.open({
      onOkClick: () => {
        this.inputUserId = ''
        this.integrationInputUserId.focus()
      }
    })
  }
}
